import { AVATARS_BUCKET } from '../config';

/**
 * Gets user avatar URL with fallback to default.png
 * @param {string} userSub - User's sub identifier
 * @returns {Promise<string>} - Resolved avatar URL
 */
export const getUserAvatarUrl = (userSub) => {
  const baseUrl = `https://${AVATARS_BUCKET}.s3.amazonaws.com`;
  const userAvatarUrl = `${baseUrl}/${userSub}.png`;
  const defaultAvatarUrl = `${baseUrl}/default.png`;
  
  return new Promise((resolve) => {
    if (!userSub) {
      resolve(defaultAvatarUrl);
      return;
    }
    
    const img = new Image();
    img.onload = () => resolve(userAvatarUrl);
    img.onerror = () => resolve(defaultAvatarUrl);
    img.src = userAvatarUrl;
  });
};

/**
 * Gets user avatar URL synchronously (immediate fallback)
 * Use this when you don't want to wait for image validation
 * @param {string} userSub - User's sub identifier
 * @returns {string} - Avatar URL (defaults to default.png if no userSub)
 */
export const getUserAvatarUrlSync = (userSub) => {
  const baseUrl = `https://${AVATARS_BUCKET}.s3.amazonaws.com`;
  return userSub ? `${baseUrl}/${userSub}.png` : `${baseUrl}/default.png`;
};

/**
 * Preloads avatar images for better performance
 * @param {string[]} userSubs - Array of user sub identifiers
 * @returns {Promise<Object>} - Map of userSub to resolved URL
 */
export const preloadAvatars = async (userSubs) => {
  const avatarMap = {};
  
  const promises = userSubs.map(async (userSub) => {
    const url = await getUserAvatarUrl(userSub);
    avatarMap[userSub] = url;
  });
  
  await Promise.all(promises);
  return avatarMap;
};
